import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DisplayLocale, ToastProvider } from '@kanos/ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { watchActivity } from './activity.js';
import { AppErrorBoundary } from './app-error-boundary.js';
import { watchNetwork } from './connection.js';
import { ConnectionNotice } from './connection-notice.js';
/** The data cache of an app: answers count as fresh for half a minute, a failure is tried once more. */
export const newQueryClient = () => new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: 1 } } });
/**
 * Starts a Kanos browser app in `#root`: strict mode, the German display locale, the data cache
 * and the toasts around its content - and a last net under it, so an error no page caught shows a
 * way back instead of an empty window (`AppErrorBoundary`). The same frame for every app.
 */
export function mountApp(content, queryClient = newQueryClient()) {
    const root = document.getElementById('root');
    if (!root)
        throw new Error('Missing #root element');
    watchActivity();
    watchNetwork();
    createRoot(root).render(_jsx(StrictMode, { children: _jsx(DisplayLocale, { children: _jsx(QueryClientProvider, { client: queryClient, children: _jsxs(ToastProvider, { children: [_jsx(AppErrorBoundary, { children: content }), _jsx(ConnectionNotice, {})] }) }) }) }));
}
//# sourceMappingURL=mount.js.map